export const mfaOptionsMap = {
  sms: 'sms',
  email: 'email',
}

export const mfaOptions = Object.values(mfaOptionsMap)
